import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

/**
 * The single RTK Query API all endpoints are injected into.
 *
 * Everything goes through our proxy at `/api`. Nothing in this application
 * talks to okmaps.org directly - their GeoServer sends no CORS headers, so a
 * direct browser fetch fails outright. The proxy also normalizes their XML,
 * strips geometry from identify responses, and enforces the request guardrails.
 *
 * Cache lifetimes are long by RTK Query standards because the upstream data
 * changes on a daily-to-monthly cadence while a browsing session lasts minutes.
 * Refetching a catalog that has not moved is pure latency.
 */
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env['VITE_API_BASE'] ?? '/api',
  }),
  tagTypes: ['Catalog', 'Layer', 'Legend', 'Metadata'],
  // 10 minutes. The catalog is fetched once and reused for the whole session.
  keepUnusedDataFor: 600,
  refetchOnMountOrArgChange: false,
  refetchOnFocus: false,
  refetchOnReconnect: true,
  endpoints: () => ({}),
});
